import styled, { css } from 'styled-components';

export const Container = styled.div``;

export const Tabela = styled.div`
  display: flex;
  flex-direction: column;
  place-content: center;
  margin: 16px 8px;
  background-color: #f3f3f3;
  width: 90vw;

  align-items: center;

  .react-grid-Grid {
    margin-bottom: 8px;
    user-select: text;
  }

  .react-grid-Cell__value {
    padding: 8px 0px;
  }

  h1 {
    color: #2c73e9;
    margin-top: 16px;
    margin-bottom: 8px;
  }

  .inputDiv {
    background-color: #fbfbfb;

    /* filter: drop-shadow(0px 2px 10px rgba(0, 0, 0, 0.25)); */
    border-radius: 8px;
    padding: 16px;
    min-width: 350px;

    display: flex;
    align-items: center;

    border: 2px solid #aaa;
    color: #999999;

    input {
      flex: 1;
      border: 0;
      background: transparent;

      color: #000000;

      &::placeholder {
        color: #999999;
      }
    }
    svg {
      margin-right: 16px;
    }
  }

  button:hover {
    transition: 0.2s;
    background-color: #c1c1c1;
  }

  button {
    border: 1px solid #2c73e9 !important;
    border-radius: 8px;
    color: #2c73e9 !important;
    font-size: 16px !important;
    font-weight: 500 !important;
    margin-bottom: 8px !important;
    background-color: #f3f3f3;
  }

  main {
    background-color: #f3f3f3;
    border: 1px solid #2f80ed;
    border-radius: 8px;
    /* padding: 16px 0 0 0; */
    margin-bottom: 16px;
    max-width: 100vw;
    min-width: 25vw;

    div {
      border: 1px solid #2f80ed;
      width: 50%;
    }

    h2 {
      border: 1px solid #2f80ed;

      padding: 8px 0;
      background-color: #2f80ed;
      border-radius: 5px 5px 0 0;

      color: #fff;
      text-align: center;
    }

    p {
      display: flex;
      justify-content: space-between;

      margin: 8px;
    }

    strong {
      /* color: #2f80ed; */
      /* text-decoration: underline; */
    }
  }
`;